import { render } from "./ForgotPasswordConfirmation.vue?vue&type=template&id=38a3ff7b"
import script from "./ForgotPasswordConfirmation.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__